import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import UnProtectedLayout from 'components/layouts/UnProtectedLayout';
import { SITE } from 'config/config';
import { CONST_SITE } from 'utils/common/const';

const Football = lazy(() => import('pages/Home/Football'));
const FootballNew88 = lazy(() => import('pages/New88/FootballNew88'));
const Lottery = lazy(() => import('pages/Home/Lottery'));
const LotteryNew88 = lazy(() => import('pages/New88/LotteryNew88'));
const New88Page = lazy(() => import('pages/New88'));
const PageError = lazy(() => import('pages/Error'));
const LandingPage = lazy(() => import('pages/Home/LandingPage'));
const LandingPageNew88 = lazy(() => import('pages/New88/LandingPageNew88'));
const EsportNew88 = lazy(() => import('pages/New88/EsportNew88'));

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<UnProtectedLayout />}>
        <Route index element={SITE === CONST_SITE.NEW88 ? <LandingPageNew88 /> : <LandingPage />} />
        {SITE === CONST_SITE.NEW88 ? (
          <>
            <Route path="/home-ddtt-new88" element={<FootballNew88 />} />
            <Route path="/home-ddxs-new88" element={<LotteryNew88 />} />
            <Route path="/home-esport-new88" element={<EsportNew88 />} />
          </>
        ) : (
          <>
            <Route path="/home-ddtt" element={<Football />} />
            <Route path="/home-ddxs" element={<Lottery />} />
          </>
        )}
      </Route>
      <Route path="*" element={<PageError />} />
    </Routes>
  );
};

export default AppRoutes;
